import { render, staticRenderFns } from "./heroimage.vue?vue&type=template&id=22daddf8&scoped=true&"
import script from "./heroimage.vue?vue&type=script&lang=js&"
export * from "./heroimage.vue?vue&type=script&lang=js&"
import style0 from "./heroimage.vue?vue&type=style&index=0&id=22daddf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22daddf8",
  null
  
)

export default component.exports